module.exports = __webpack_public_path__ + "static/media/Full-Bike small.be4db28b.png";